import checkoutConfirmationHtml from './checkoutconfirmation.component.html';
import './checkoutconfirmation.component.scss';

class CheckoutConfirmationController {
    constructor($scope, $sce, $window, CheckoutService, SnackbarService, translateService) {
        'ngInject';

        this.$scope = $scope;
        this.$sce = $sce;
        this.service = CheckoutService;
        this.SnackbarService = SnackbarService;
        this.translate = translateService;
        this.countries = this.service.countries;

        const invoiceAddressChangeWatch = this.$scope.$watch(() => this.service.data.invoiceAddressId, (newVal, oldVal)  => {
            if (this.service.data.invoiceAddressId) {
                this.service.setAddressesFromId();
                invoiceAddressChangeWatch();
            }
        }, true);
    }

    getCountryName(countryCode) {
        return this.countries[countryCode];
    }
}

let checkoutConfirmationComponent = {
    bindings: {},
    template: checkoutConfirmationHtml,
    controller: CheckoutConfirmationController
}

export default checkoutConfirmationComponent;
